var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { UserManager } from 'oidc-client';
import { BehaviorSubject } from 'rxjs';
import { from } from 'rxjs';
import { config } from '@environments/environment';
import { Endpoints } from '@config/endpoints';
import { Constants } from '@config/constants';
import { DataService } from '@core/services/DataService';
var SessionService = /** @class */ (function () {
    function SessionService(dataService) {
        this.dataService = dataService;
        this.isLoggedIn = new BehaviorSubject(false);
        this.identity = new BehaviorSubject(null);
        this.manager = new UserManager({
            authority: config.identityBaseUrl,
            client_id: 'js.sf.admin',
            redirect_uri: config.publicUrl + "/callback.html",
            response_type: 'id_token token',
            scope: 'openid profile sf-admin-api',
            post_logout_redirect_uri: config.publicUrl + "/signout-callback-oidc",
        });
    }
    SessionService.prototype.loadProfile = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.dataService.request(Endpoints.Profile)];
                    case 1:
                        response = _a.sent();
                        this.identity.next(response);
                        return [2 /*return*/, response];
                }
            });
        });
    };
    SessionService.prototype.startSession = function () {
        var session = this.getSession();
        if (session) {
            this.isLoggedIn.next(true);
        }
    };
    SessionService.prototype.hasSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var session;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSession()];
                    case 1:
                        session = _a.sent();
                        return [2 /*return*/, !!session && !!session.access_token];
                }
            });
        });
    };
    SessionService.prototype.getSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var session;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.manager.getUser()];
                    case 1:
                        session = _a.sent();
                        return [2 /*return*/, session];
                }
            });
        });
    };
    SessionService.prototype.setSession = function (session) {
        if (session) {
            window.localStorage.setItem(Constants.accessTokenAlias, session.accessToken);
            this.isLoggedIn.next(true);
        }
    };
    SessionService.prototype.observeSession = function () {
        return from(this.getSession());
    };
    SessionService.prototype.resetSession = function () {
        window.localStorage.removeItem(Constants.accessTokenAlias);
        this.isLoggedIn.next(false);
        this.requireLogin();
    };
    SessionService.prototype.requireLogin = function () {
        this.manager.signinRedirect();
    };
    SessionService.prototype.loginCallback = function () {
        return this.manager.signinRedirectCallback();
    };
    SessionService.prototype.logout = function () {
        window.localStorage.removeItem(Constants.accessTokenAlias);
        this.manager.signoutRedirect();
    };
    return SessionService;
}());
export { SessionService };
